<template>
  <div>
    <b-card
      title="Görsel"
      sub-title="Türkçe"
    >
      <b-img
        v-if="itemData.image_tr"
        :src="imageUrl + '/media/home_page/' + itemData.image_tr"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('home_page')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="home_page"
      :params="cropperSettings.type"
      :item-id="itemData.id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>

<script>
import { BButton, BCard, BImg } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'

export default {
  name: 'ImageCard',
  components: {
    CropperImage, BCard, BButton, BImg,
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['homePage/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'home_page') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'home_page-image.jpg',
          folder: 'home_page',
          ratio: null,
          widthSize: 1600,
          type: 'tr',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      }
    },
    setUploadImage(item) {
      if (this.cropperSettings.type === 'home_page') {
        this.itemData.image_tr = item.filename
        this.itemData.thumb_tr = item.thumb
        this.itemData.image_webp_tr = item.filename_webp
        this.itemData.thumb_webp_tr = item.thumb_webp
        this.itemData.mediaData_tr = item
      }
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
